import { render, staticRenderFns } from "./ChatModal.vue?vue&type=template&id=69730a65&"
import script from "./ChatModal.vue?vue&type=script&lang=ts&"
export * from "./ChatModal.vue?vue&type=script&lang=ts&"
import style0 from "./ChatModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports